import React, { useState } from "react";
import { FaCommentDots, FaPaperPlane } from "react-icons/fa";
import "./Feedback.css";

export default function Feedback() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const subject = "SnapConX website feedback";
    const body = [
      `Name: ${form.name}`,
      `Email: ${form.email}`,
      "",
      "Feedback:",
      form.message,
    ].join("\n");
    window.location.href = `mailto:info@dotanddash.co.za?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <section className="feedback-page">
      <div className="feedback-intro">
        <div className="feedback-icon" aria-hidden="true"><FaCommentDots /></div>
        <p className="feedback-eyebrow">We value your input</p>
        <h1>Send feedback</h1>
        <p>Tell us what is working well, what could be better, or what you would like to see next.</p>
      </div>

      <form className="feedback-form" onSubmit={handleSubmit}>
        <label htmlFor="feedback-name">Name</label>
        <input id="feedback-name" name="name" value={form.name} onChange={handleChange} autoComplete="name" required />

        <label htmlFor="feedback-email">Email address</label>
        <input id="feedback-email" name="email" type="email" value={form.email} onChange={handleChange} autoComplete="email" required />

        <label htmlFor="feedback-message">Your feedback</label>
        <textarea id="feedback-message" name="message" value={form.message} onChange={handleChange} rows="7" required />

        <button type="submit"><FaPaperPlane /> Continue to email</button>
        <p className="feedback-note">Your email app will open with your feedback ready to send to SnapConX support.</p>
      </form>
    </section>
  );
}
